import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from './content'

import { Menu, MenuItem } from '@material-ui/core'
import SnackbarService from '../../services/snackbars'
import * as UsersActions from '../../store/user/actions'

import { CropImage, Header } from 'components'

import './style.scss'

export interface IForm {
  title: string
  description: string
  name: string
  profession: string
  location: string
}

export interface IProps {
  user: any
  UsersActions: any
}

export interface IState {
  anchorEl: any
  page: 'profile' | 'crop-avatar'
  image: any
  croppedImage: any
}

class ParentProfile extends React.PureComponent<IProps, IState> {
  state: IState = {
    anchorEl: null,
    page: 'profile',
    image: null,
    croppedImage: null
  }

  handleProfileMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = (action?: string) => {
    switch (action) {
      case 'logout':
        window.location.href = window.location.origin
        break
      case 'edit':
        alert('coming soon')
        break
    }
    this.setState({ anchorEl: null })
  }

  handleFiles = ({ base64 }) => {
    const { page } = this.state
    if (page === 'profile' && base64.includes('image')) {
      this.setState({ page: 'crop-avatar', image: base64 })
    }
  }

  onSubmitCrop = croppedImage => {
    const {
      user: { userId }
    } = this.props
    this.setState({ page: 'profile', croppedImage })

    this.props.UsersActions.uploadImage(
      croppedImage,
      userId,
      () => {
        SnackbarService.showSnackbar(
          'The avatar has been updated successfully',
          'success'
        )
      },
      message => {
        SnackbarService.showSnackbar(message, 'error')
      }
    )
  }

  onCancelCrop = () => {
    this.setState({ page: 'profile' })
  }

  render() {
    const {
      user: { full_name, avatar_url }
    } = this.props
    const { anchorEl, image, page, croppedImage } = this.state

    if (page === 'crop-avatar') {
      return (
        <CropImage
          onSubmit={this.onSubmitCrop}
          onCancel={this.onCancelCrop}
          image={image}
        />
      )
    } else if (page === 'profile') {
      return (
        <div>
          <Header
            rightSide={
              <button
                onClick={this.handleProfileMenuClick}
                className="edit-profile"
              />
            }
            disableBackButton={true}
            smallHeader={true}
          />
          <Content
            image={croppedImage}
            avatar={avatar_url}
            name={full_name}
            handleFiles={this.handleFiles}
          />

          <Menu
            id="profile-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => this.handleClose()}
          >
            <MenuItem onClick={() => this.handleClose('edit')}>
              Edit Profile
            </MenuItem>
            <MenuItem onClick={() => this.handleClose('logout')}>
              Logout
            </MenuItem>
          </Menu>
        </div>
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    UsersActions: bindActionCreators<any, any>(UsersActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParentProfile)



// WEBPACK FOOTER //
// ./src/pages/ParentProfile/index.tsx